module.exports = __webpack_public_path__ + "img/done-gray.2016b5c7.svg";